export default {
  NODE_REMOVED: 'DOMNodeRemovedFromDocument',
  LOAD: 'load'
};
